import * as React from 'react'

import Chip from '@mui/material/Chip'
import Box from '@mui/material/Box'

import { FilterItem } from 'pages/wiki/filters'
import Modal from 'components/atomic/molecules/modal'

interface WikiFiltersModalProps {
    open: boolean
    onClose: () => void
    items: FilterItem[]
    activeFilters: FilterItem[]
    onAdd: (item: FilterItem) => void
    onRemove: (slug: string) => void
    title: string
}

const WikiFiltersModal = (props: WikiFiltersModalProps) => {
    const handleChipClick = React.useCallback(
        (filter: FilterItem) => () => {
            const exists = props.activeFilters.find((item) => item.slug === filter.slug)

            if (exists) {
                props.onRemove(filter.slug)
            } else {
                props.onAdd(filter)
            }
        },
        [props],
    )

    return (
        <Modal title={props.title} open={props.open} onClose={() => props.onClose()} sx={{}}>
            <div>
                <Box display="flex" flexWrap="wrap" gap={1} marginY={2} maxHeight={'50vh'} overflow={'scroll'}>
                    {props.items.map((filter) => {
                        const active = props.activeFilters.some((i) => i.slug === filter.slug)
                        return (
                            <Chip
                                size="small"
                                key={filter.slug}
                                label={filter.title}
                                onClick={handleChipClick(filter)}
                                onDelete={active ? handleChipClick(filter) : undefined}
                                variant={active ? 'filled' : 'outlined'}
                            />
                        )
                    })}
                </Box>
            </div>
        </Modal>
    )
}

export default WikiFiltersModal
